// extracted by mini-css-extract-plugin
export default {"element":"element--qHg+","title":"title--K6D4"};